/**
 * @file
 * A JavaScript file containing the main menu functionality (small/large screen)
 *
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function (Drupal, $, once) {
  Drupal.behaviors.mainMenu = {
    attach: function (context) {
      "use strict";
        $(once('main-menu', ".header.simple-menu"))
        .each(function () {
          $(document).on(
            "click",
            "#global-header .main-nav> .main-menu.level-0> .main-menu__item--with-sub>button",
            function (e) {
              e.stopPropagation();
              var item = $(this).parent();

              if (window.matchMedia("(min-width: 1200px)").matches) {
                if (item.hasClass("is-open")) {
                  item.removeClass("is-open");
                  item
                    .children(".menu_second_level__wrapper")
                    .removeClass("expanded")
                    .stop()
                    .fadeOut(300);
                  $(".bg-dark").removeClass("active");
                } else {
                  $(
                    ".main-nav> .main-menu.level-0> .main-menu__item--with-sub.is-open"
                  ).removeClass("is-open");
                  $(".menu_second_level__wrapper.expanded").stop().fadeOut(300);
                  item.addClass("is-open");
                  item
                    .children(".menu_second_level__wrapper")
                    .addClass("expanded")
                    .stop()
                    .fadeIn(300);
                  $(".bg-dark").addClass("active");
                }
              }
            }
          );
          $(document).on(
            "click",
            "#global-header .menu_second_level__wrapper button.close",
            function () {
              $(this)
                .closest(".menu_second_level__wrapper")
                .removeClass("expanded")
                .stop()
                .fadeOut(300);
              $(this)
                .closest(".main-menu__item.is-open")
                .removeClass("is-open");
              $(".bg-dark").removeClass("active");
            }
          );

          $(document).on("click", ".bg-dark.active", function () {
            $(this).removeClass("active");
            if (window.matchMedia("(min-width: 1200px)").matches) {
              $(
                ".main-nav> .main-menu.level-0> .main-menu__item--with-sub.is-open"
              ).removeClass("is-open");
              $(".menu_second_level__wrapper.expanded").stop().fadeOut(300);
            } else {
              $("#search-block-form").stop().slideUp(200);
              $(".header.simple-menu #block-mainnavigation-2")
                .stop()
                .slideUp(200);

              $(".hamburger-menu__wrapper, .search-icon")
                .removeClass("active")
                .show();

              if ($(this).hasClass("heigher")) {
                $(this).removeClass("heigher");
                $("#block-sitewidealert").addClass("mini");
              }
            }
          });

          $(".bottom-menu #block-searchform input[type=search]").on(
            "keyup",
            function () {
              var form = $(this).closest("form");

              if ($(this).val().length > 0) {
                if (!form.children(".search-clear").length) {
                  form.append(
                    '<button class="search-clear" type="button" title="Clear the search"></button>'
                  );
                }
              } else {
                form.children(".search-clear").remove();
              }

              //fixing search autocomplete missing search all term
              var target = document.querySelector(
                "#search-block-form .ui-menu.ui-widget"
              );

              var MutationObserver =
                window.MutationObserver || window.WebKitMutationObserver;

              var observer = new MutationObserver(function (mutations) {
                mutations.some(function (mutation) {
                  if (mutation.type === "childList") {
                    if (
                      !$("#search-block-form .ui-menu.ui-widget>.ui-menu-item")
                        .last()
                        .hasClass("ui-menu-item-first")
                    ) {
                      $("#search-block-form .ui-menu.ui-widget").append(
                        `<div class="ui-autocomplete-field-group ui-state-disabled more_results ui-menu-divider ui-widget-content" aria-disabled="true"></div><li class="ui-menu-item-first ui-menu-item overriden-search"><a id="ui-id-7" tabindex="-1" class="ui-menu-item-wrapper"><div class="ui-autocomplete-fields first"><div class="ui-autocomplete-field">See all results</div></div></a></li>`
                      );
                    }
                  }
                });
              });

              var config = { childList: true };
              observer.observe(target, config);

              $(document).on("click", ".overriden-search", function () {
                $(
                  ".bottom-menu #block-searchform .form-actions .button"
                ).click();
              });
            }
          );

          $(document).on(
            "click",
            "#block-searchform .search-clear",
            function () {
              $(this).closest("form").find("input[type=search]").val("");
              $(this).remove();
            }
          );

          //MOBILE
          //merging menus
          function mergeMenus() {
            if (window.matchMedia("(min-width: 1200px)").matches) {
              $("#block-mainnavigation-2 ul.main-menu >li.temporary").remove();
              $("#block-mainnavigation-2").removeClass("mobile-menu");
            } else if (
              !$("#block-mainnavigation-2 ul.main-menu >li.temporary").length
            ) {
              $("#block-mainnavigation-2").addClass("mobile-menu");
              $("#block-mainnavigation-2 ul.main-menu").append(
                $("#block-topmenu ul.main-menu > li")
                  .clone()
                  .addClass("temporary")
              );
            }

            if (!window.matchMedia("(min-width: 1200px)").matches) {
                $(once('match-media-1200', "#block-mainnavigation-2 .mobile-only-controls.home"))
                .prepend(
                  $(
                    "#block-toplinks .field--name-field-links .field__item:last-of-type a"
                  ).clone()
                );
            }
          }
          mergeMenus();

          $(window).on("resize", function () {
            mergeMenus();
          });

          //Hamburger
          $(".hamburger-menu__wrapper").on("click", function () {
            $(this).toggleClass("active");
            $(".header.simple-menu #block-mainnavigation-2")
              .stop()
              .slideToggle(300);

            //Hiding search
            $("#search-block-form").stop().slideUp(200);
            $(".search-icon").removeClass("active").toggle();

            $(this).hasClass("active")
              ? $(".bg-dark").addClass("active")
              : $(".bg-dark").removeClass("active");
          });

          //Search
          $(".search-icon").on("click", function () {
            if ($("form#checker-form").length) {
              window.location.href = "/search";
            }

            if (window.matchMedia("(min-width: 1200px)").matches) {
              $(this).toggleClass("active");
              $(
                ".main-nav> .main-menu.level-0> .main-menu__item--with-sub.is-open"
              ).removeClass("is-open");
              $(".menu_second_level__wrapper.expanded").stop().fadeOut(300);
              $(".bg-dark").removeClass("active");

              $("#block-mainnavigation-2").stop().fadeToggle(150);
              $("#block-searchform").toggleClass("visible").fadeToggle(150);
              $(".bottom-menu #block-searchform input[type=search]")
                .get(0)
                .focus();
            } else {
              $(this).toggleClass("active");
              $("#search-block-form").stop().slideToggle(200);

              //Hiding Menu
              $(".header.simple-menu #block-mainnavigation-2")
                .stop()
                .slideUp(300);
              $(".hamburger-menu__wrapper").removeClass("active").toggle();

              $(this).hasClass("active")
                ? $(".bg-dark").addClass("active")
                : $(".bg-dark").removeClass("active");
            }
          });

          //Mobile nav
          //first level
          $(document).on(
            "click",
            "#block-mainnavigation-2.mobile-menu .main-menu.level-0 >.main-menu__item--with-sub",
            function () {
              var $this = $(this);
              $this.addClass("expanded");
              $this.siblings().fadeOut(250);
              $(".mobile-only-controls.home").fadeOut(250);
              $this.children(".menu_second_level__wrapper").fadeIn(250);
            }
          );
          //second level
          $(document).on(
            "click",
            "#block-mainnavigation-2.mobile-menu .menu_second_level__wrapper >.container >ul >.main-menu__item--with-sub",
            function () {
              var $this = $(this);
              $this.addClass("expanded");
              $this.siblings().fadeOut(250);
              $this.parent().siblings().fadeOut(250);
              $this.children(".menu_third_level__wrapper").fadeIn(250);
            }
          );
          //Back
          $(document).on(
            "click",
            "#block-mainnavigation-2.mobile-menu .mobile-only-controls.back",
            function (e) {
              e.stopPropagation();

              var $this = $(this);
              var parentItem = $this.closest(".expanded");
              parentItem.children(".sustained").fadeOut(250);
              parentItem.removeClass("expanded");
              parentItem.siblings().fadeIn(250);
              if (
                parentItem
                  .children(".sustained")
                  .hasClass("menu_second_level__wrapper")
              ) {
                $(".mobile-only-controls.home").fadeIn(250);
              } else {
                parentItem.parent().siblings().fadeIn(250);
              }
            }
          );

          //Sticky hide menu on scheme page
          $(window).on("scroll", function () {
            if ($("#in-page-nav-wrapper").length) {
              if (
                $("#in-page-nav-wrapper").offset().top <= $(window).scrollTop()
              ) {
                $("#global-header").addClass("hide");
              } else {
                $("#global-header").removeClass("hide");
              }
            }

            if ($(window).scrollTop() > 0) {
              $("#global-header").addClass("is-sticky");
            } else {
              $("#global-header").removeClass("is-sticky");
            }
          });
        }); // once

      //sidebar menu

      $(once('sidebar-menu-once', ".sidebar-menu .main-nav"))
        .each(function () {
          //sidebar adjustment after the block loads
          $(once('sidebar-adjustment', ".sidebar-menu .main-nav> .main-menu.level-0> .main-menu__item--with-sub>button.main-menu__link"))
            .each(function () {
              if (
                $(this)
                  .parent()
                  .find(".mega-menu-title a.menu-title")
                  .attr("href")
              ) {
                $(this).addClass("clickable");
              }
            });

          $(document).on(
            "click",
            ".sidebar-menu .main-nav> .main-menu.level-0> .main-menu__item--with-sub>button.main-menu__link",
            function (e) {
              e.stopPropagation();

              var href = $(this)
                .parent()
                .find(".mega-menu-title a.menu-title")
                .attr("href");

              if (href) {
                window.location.href = href;
              }
            }
          );

          $(document).on(
            "click",
            ".sidebar-menu .main-nav> .main-menu.level-0> .main-menu__item--with-sub",
            function (e) {
              e.stopPropagation();

              var $this = $(this);
              $this
                .toggleClass("is-open")
                .children(".menu_second_level__wrapper")
                .stop()
                .slideToggle(300);

              $this
                .siblings()
                .removeClass("is-open")
                .children(".menu_second_level__wrapper")
                .stop()
                .slideUp(300);
            }
          );

          $(".sidebar-menu")
            .find(
              ".main-nav> .main-menu.level-0> .main-menu__item--with-sub .expand-sub"
            )
            .each(function () {
              $(this).replaceWith($("<button class='expand-sub'></button>"));
            });

          $(document).on(
            "click",
            ".sidebar-menu .main-nav> .main-menu.level-0> .main-menu__item--with-sub .expand-sub",
            function (e) {
              e.stopPropagation();

              $(this).parent(".main-menu__item--with-sub").click();
            }
          );

          $(document).on(
            "click",
            ".sidebar-menu .main-nav> .main-menu.level-0> .main-menu__item--with-sub a",
            function (e) {
              e.stopPropagation();
            }
          );

          $(".sidebar-menu")
            .find(".main-menu__item.main-menu__item--active")
            .addClass("is-open");

          setTimeout(() => {
            $(".sidebar-menu")
              .find(".main-menu__item.main-menu__item--active:not(.is-open)")
              .addClass("is-open");
          }, 1000);
        });

      //Skip to content
      $(document).on("click", ".focusable.skip-link", function (e) {
        e.preventDefault();
        var target = $(this).attr("href");
        $(target).focus();
        if (target) {
          $("html, body")
            .stop()
            .animate({
              scrollTop:
                $(target).offset().top + 4 - $("#global-header").height(),
            });
        }
      });

      //property price caps
      if ($('body').hasClass("page-node-type-property-price-caps")) {
        //search functionality
        function adjustAfterAJAX() {
          if ($(".view.view-tools .view-header").length) {
            var searchTerm = $(
              "#views-exposed-form-tools-block-1 input.form-text"
            ).val();

            $(".view.view-tools .view-header>span").text(searchTerm);

            //search icon
            if (
              $("#views-exposed-form-tools-block-1 input[type=text]").val()
                .length > 0
            ) {
              $(once('form-tools-block', "#views-exposed-form-tools-block-1 .js-form-type-textfield"))
                .append(
                  '<button class="search-clear" type="button" title="Clear the search"><span></span></button>'
                );
            }
          }
        }

        adjustAfterAJAX();

        $(document).ajaxComplete(function (e, xhr, settings) {
          if (settings.url.indexOf("/autocompletion-callback") == -1) {
            adjustAfterAJAX();
          }
        });

        //Search autocomplete
        $(once('search-auto-js', "#views-exposed-form-tools-block-1 input[type=text]"))
          .on("keyup", function () {
            var form = $(this).closest("form");
            var search = $(this).parent(".js-form-type-textfield");
            var val = $(this).val();

            //Add close
            if (val.length > 0) {
              if (!search.children(".search-clear").length) {
                search.append(
                  '</div><button class="search-clear" type="button" title="Clear the search"><span></span></button>'
                );
              }
              if (!search.children(".autocomplete-wrapper").length) {
                search.append('<div class="autocomplete-wrapper"></div>');
              }
            } else {
              search.children(".search-clear").remove();
            }

            //Autocomlete
            if (val.length > 0) {
              $.ajax("/autocompletion-callback?combine=" + val, {
                success: function (data) {
                  updateAutoComplete(data, val, search);
                },
              }).done(function (data) {
                updateAutoComplete(data, val, search);
              });
            } else {
              search.children(".autocomplete-wrapper").children().remove();
            }
          });

        //autocomplete function
        var updateAutoComplete = function (response, val, search) {
          var results = response.slice(0, 25);
          search.children(".autocomplete-wrapper").children().remove();
          if (results.length) {
            $(results).each(function () {
              var title = $(this)[0].title;
              search
                .find(".autocomplete-wrapper")
                .append(
                  `<div class="autocomplete-option" data-val="${title}">${title}</div>`
                );
            });
          }
        };

        //Select autocomplete option
        $(document).on(
          "click",
          "#views-exposed-form-tools-block-1 .autocomplete-option",
          function () {
            var text = $(this).text();
            var search = $(this).closest("form").find("input[type=text]");

            search.val(text);
            search.focus();
            $(this).parent().children().remove();
            $("#views-exposed-form-tools-block-1 input.form-submit").click();
          }
        );

        //close autocomplete dropdown
        $(document).mouseup(function (e) {
          var container = $(
            "#views-exposed-form-tools-block-1 .autocomplete-wrapper"
          );
          if (
            !container.is(e.target) &&
            container.find(e.target).length === 0
          ) {
            container.children().remove();
          }
        });

        //Search close
        $(document).on(
          "click",
          "#views-exposed-form-tools-block-1 .search-clear",
          function (e) {
            e.preventDefault();
            $(this).closest("form").find("input[type=text]").val("").focus();
            $(this)
              .closest(".view.view-tools")
              .find(".view-header, .view-content")
              .remove();
            $(this).remove();
          }
        );
      }
    },
  };
}(Drupal, jQuery, once));
